exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".time_list[data-v-700c004b]{display:flex;flex-direction:column;gap:0.0625rem}.time_list .tItem[data-v-700c004b]{padding-left:0.3125rem;display:flex;align-items:center;gap:0.08333rem}.time_list .tItem .i_time.error[data-v-700c004b]{color:#f56c6c}.time_list .tItem .i_txt[data-v-700c004b]{flex:1;text-align:center}\n", ""]);

// exports
